import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IForgotPasswordGeneratePinEntity } from '../../../entity';

export interface IForgotPasswordGeneratePinByEmailUseCase {
    execute(email: string): Promise<IForgotPasswordGeneratePinEntity>;
}

export class ForgotPasswordGeneratePinByEmailUseCase implements IForgotPasswordGeneratePinByEmailUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(email: string): Promise<IForgotPasswordGeneratePinEntity> {
        return await this.userRepo.forgotPasswordGeneratePinByEmail(email);
    }
}
